// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

const BANK_CHANNEL_EWALLETS = ['mobile-banking', 'duitnow-pay'];

export async function ewalletOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  const baseData = {
    payment_type: 'ewallet',
    payment_type_code: userInputValues['selectedEWallet'],
  };

  const selectedEWallet = userInputValues['selectedEWallet'];

  if (selectedEWallet === 'yape') {
    return {
      ...baseData,
      customer_device_info: {
        source: getDeviceSource(),
      },
    };
  }

  if (BANK_CHANNEL_EWALLETS.includes(selectedEWallet)) {
    return {
      ...baseData,
      bank_details: {
        bank_code: userInputValues['selectedBankCode'],
        account_number: '',
      },
    };
  }

  return baseData;
}

function getDeviceSource(): string {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent) ? 'mobile' : 'web';
}
